import React, { useRef, useState } from 'react';
import { DropdownItem } from 'reactstrap';
import { MoreVertical } from 'react-feather';
import PortalDropdown from './PortalDropdown'; // Your portal wrapper

type DropdownAction<T> = {
    label: string | ((row: T) => string);
    icon?: React.ReactNode | ((row: T) => React.ReactNode);
    onClick: (row: T) => void;
};

interface ActionDropdownProps<T> {
    row: T;
    actions: DropdownAction<T>[];
}

const ActionDropdown = <T extends unknown>({ row, actions }: ActionDropdownProps<T>) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const toggleDropdown = () => setIsOpen(prev => !prev);

    const getLabel = (action: DropdownAction<T>) => {
        return typeof action.label === 'function' ? action.label(row) : action.label;
    };

    const getIcon = (action: DropdownAction<T>) => {
        return typeof action.icon === 'function' ? action.icon(row) : action.icon;
    };

    return (
        <>
            <button
                ref={buttonRef}
                className="btn p-0 m-0 border-0 shadow-none"
                onClick={toggleDropdown}
                style={{ zIndex: 10 }}
            >
                <MoreVertical size={18} />
            </button>

            <PortalDropdown
                targetRef={buttonRef as React.RefObject<HTMLElement>}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            >
                {actions.map((action, idx) => (
                    <div
                        key={idx}
                        onClick={() => {
                            action.onClick(row);
                            setIsOpen(false); // Close dropdown after action
                        }}
                        style={{ cursor: 'pointer', padding: '0.5rem 1rem', border: '0.4px solid #474545', }}
                    >
                        {/* {action.icon && <span className="me-2">{action.icon}</span>}
                        {action.label} */}
                        {getIcon(action) && <span className="me-2">{getIcon(action)}</span>}
                        {getLabel(action)}
                    </div>
                ))}
            </PortalDropdown>
        </>
    );
};

export default ActionDropdown;
